module.exports = __webpack_public_path__ + "img/wggl.74bd7b92.png";